/* global submitPayment formValidation ga submitReservation scrollOnEvent*/
const reservationHelper = {
	el: {
		formReservation: document.querySelector('.js-form-reservation'),
		btnRemoveDiscount: document.querySelector('.js-remove-discount'),
		inputJsRatePlan: document.querySelector('.js-rateplan'),
		containerSummary: document.querySelector('.content__summary')
	},

	vars: {
		finalPrice: 0,
		extraLargeAndUp: window.matchMedia('(min-width: 75em)'),
		mediumAndUp: window.matchMedia('(min-width: 48em)')
	},

	fxUpdateDesktopTableStylesColumns(target, tableCells) {
		const activeTab = target.closest('.tab-header'),
			remainingTabs = activeTab.parentElement.querySelectorAll('.tab-header')

		//update table header tabs
		remainingTabs.forEach(el => el.classList.remove('tab-header--column-active'))
		activeTab.classList.add('tab-header--column-active')
		document.querySelector('.form-table__warning-text').textContent = target.dataset.warning
		document.querySelector('.hero-information__warning').textContent = target.dataset.warning

		//update table content tabs
		tableCells.forEach(el => target.value === el.dataset.rateplan ? el.classList.add('tab-inner-row--column-active') : el.classList.remove('tab-inner-row--column-active'))

		document.querySelectorAll('.form-table--desktop .form-table__radio-input').forEach(input => target !== input ? input.checked = false : '')
	},

	fxUpdateDesktopTableStylesRows(target) {
		if(target.closest('.form-table__inner-row')) {
			target.value === '0' ? target.closest('.form-table__inner-row').classList.remove('row--active') : target.closest('.form-table__inner-row').classList.add('row--active')
		}
	},

	fxUpdateMobileTableStyles(target) {
		document.querySelectorAll('.form-table--mobile .form-table__radio-input').forEach(el => {
			if (target.dataset.rateplan === el.dataset.rateplan) {
				el.checked = true
				el.parentElement.classList.add('radio--active')
				document.querySelector('.hero-information__warning').textContent = target.dataset.warning
			}
			else {
				el.checked = false
				el.parentElement.classList.remove('radio--active')
			}
		})
	},

	fxSetDefaultRateInfo (container) {
		const defaultRate = container.querySelector('.tab-header--column-active'),
			heroWarning = document.querySelector('.hero-information__warning')

		heroWarning.textContent = defaultRate.querySelector('.form-table__radio-input').dataset.warning
	},

	fxLoopElements(list, attribute, currentTargetDataset) {
		list.forEach(el => el.style.display = el.dataset[attribute] === currentTargetDataset ? 'flex' : 'none')
	},

	fxGoToNextStep(button, section, formSections, headerSections) {
		const buttons = document.querySelectorAll(button)

		buttons.forEach(el => {
			el.addEventListener('click', e => {
				e.preventDefault()
				const target = e.currentTarget

				const sectionNumber = Number(section)

				//section to validate
				if (target.dataset.sectionNext - 1 === sectionNumber) {

					const reservationContainer = document.querySelector('.form--reservation')

					//-bouncer validate for section
					const sectionErrors = formValidation.fxFieldsetBouncer(`.form__tab[data-section="${sectionNumber}"]`, reservationContainer)

					if (sectionErrors.length === 0) {
						if (sectionNumber === 1) {
							//show next section according to data-section, hide siblings
							this.fxLoopElements(formSections, 'section', target.dataset.sectionNext)

							//show header tab according to data-header
							this.fxLoopElements(headerSections, 'header', target.dataset.headerNext)

							//change styles for sidepanel
							target.closest('.content-aside').classList.remove('content-aside--full-width')
							target.closest('.content__summary').classList.remove('content__summary--orange')
							target.style.display = 'none'
							target.closest('.content__summary').nextElementSibling.style.display = 'none'

							//update inputs
							this.fxUpdateAmountAfterTax()

							//show member card fields according to selected rate plan
							this.fxUpdateMemberCardFields()

							scrollOnEvent.fxScrollOnEvent(document.querySelector('.content-aside'))

							//events google analytics
							if (window.ga && ga.loaded)
								ga('send', 'event', { 'eventCategory': 'booking', 'eventAction': 'click', 'eventLabel': 'step2', 'eventValue': 1 })
						}

						if (sectionNumber === 2) {
							//submit reservation data
							submitReservation.fxSubmitReservation(target)

							//-hide remove discount btn
							this.el.btnRemoveDiscount.remove()
						}

						if (sectionNumber === 3) {
							//show next section according to data-section, hide siblings
							this.fxLoopElements(formSections, 'section', target.dataset.sectionNext)

							//submit payment method
							submitPayment.fxSubmitPaymentMethod(target)
						}
					}
				}
			})
		})
	},

	fxUpdateAmountAfterTax() {
		document.querySelector('.js-amount').value = this.vars.finalPrice
	},

	fxUpdateMemberCardFieldsHelper(element) {
		element.querySelectorAll('.form-table__radio-input').forEach(el => el.checked && document.querySelectorAll('.js-hidden-field').forEach(field => field.dataset.card === el.dataset.ratePlanName ? field.style.display = 'flex' : field.remove()))
	},

	fxUpdateMemberCardFields() {
		if (this.vars.extraLargeAndUp.matches) {
			const desktopContainer = this.el.formReservation.querySelector('.form-table--desktop')
			this.fxUpdateMemberCardFieldsHelper(desktopContainer)
		}
		else {
			const mobileContainer = this.el.formReservation.querySelector('.form-table--mobile')
			this.fxUpdateMemberCardFieldsHelper(mobileContainer)
		}
	},

	fxUpdateInputNumberHelper(input, element) {
		const mobileContainer = this.el.formReservation.querySelector('.form-table--mobile')

		input.value = Number(input.value) || 0
		mobileContainer.querySelectorAll('.form-table__radio-input').forEach(el => el.checked && this.fxUpdateMobileTableStyles(mobileContainer, '.form-table__radio-input', el))
		input.value >= 1 ? element.closest('.form-table__card').classList.add('card--active') : element.closest('.form-table__card').classList.remove('card--active')
	},

	fxUpdateCountryCode(target) {
		const selectedCountryCode = target.options[target.selectedIndex].getAttribute('data-country-code')

		document.querySelector('.js-country-code').value = selectedCountryCode
	},

	fxCalculateContentSummaryHeight() {
		const summaryContainer = document.querySelector('.content__flex-aside')

		if (!this.vars.extraLargeAndUp.matches) {
			if (summaryContainer.classList.contains('content__flex-aside--open')) {
				summaryContainer.style.bottom = '0'
			}
			else {
				const bottomValue = this.vars.mediumAndUp.matches ? Number(summaryContainer.dataset.bottomMedium) : Number(summaryContainer.dataset.bottomSmall)

				summaryContainer.style.bottom = `${-summaryContainer.offsetHeight + bottomValue}px`
			}
		}
	},

	fxToggleContentSummary(target) {
		const aside = target.closest('.content__flex-aside')

		aside.classList.contains('content__flex-aside--open') ? aside.classList.remove('content__flex-aside--open') : aside.classList.add('content__flex-aside--open')
		this.fxCalculateContentSummaryHeight()
	},

	fxUpdateRatePlanValue() {
		document.querySelectorAll('.form-table__radio-input').forEach(el => el.checked ? this.el.inputJsRatePlan.value = el.value : '')
	},

	fxUpdateInfo() {

		const selects = document.querySelectorAll('.form-table__select select'),
			reservationSummary = document.querySelector('.js-reservation-summary'),
			reservationFinalPrice = document.querySelector('.js-reservation-final-price'),
			reservationPriceContainer = document.querySelector('.content__summary-total'),
			reservationSubmitBtn = document.querySelector('.content__summary-button'),
			reservationRatePlanType = document.querySelector('.content__summary-info'),
			reservationSubtotal = document.querySelector('.js-reservation-subtotal'),
			bookingInput = document.querySelector('.js-booking')

		this.vars.finalPrice = 0
		reservationSummary.innerHTML = ''
		reservationFinalPrice.innerHTML = ''

		let ratePlanValue = null,
			ratePlanName = ''

		selects.forEach(item => {
			if (item.value !== '0') {
				const wrapper = item.closest('.js-room-info')

				if (this.vars.extraLargeAndUp.matches)
					document.querySelectorAll('.form-table--desktop .form-table__radio-input').forEach(input => input.checked ? ratePlanValue = input.value : '')

				else
					document.querySelectorAll('.form-table--mobile .form-table__radio-input').forEach(input => input.checked ? ratePlanValue = input.value : '')

				wrapper.querySelectorAll('.js-rateplan-value').forEach(el => {
					if (ratePlanValue === el.dataset.rateplan) {

						ratePlanName = el.dataset.ratePlanName

						const price = Number(el.dataset.price),
							roomPrice = (price * item.value).toFixed(2).replace('.', ','),
							//- room capacity, after roomPrice
							//- - ${wrapper.dataset.roomCapacity} ${wrapper.dataset.guestCopy}
							field = `<div class='content__summary-description-row'>
											<div class='content__summary-description-rooms'>
												<span class='js-room-units'>${Number(item.value)}</span> x
												<span class='js-room-description'>${wrapper.dataset.roomDescription}</span> 
											</div>
											<div class='content__summary-description-price'>
												= <span class='js-room-price content__summary-description-price'>${roomPrice}€</span>
											</div>
										</div>`,

							itemPrice = price * item.value
						this.vars.finalPrice += itemPrice

						reservationSummary.innerHTML += field
						reservationFinalPrice.textContent = this.vars.finalPrice.toFixed(2).replace('.', ',')
						reservationSubtotal.textContent = this.vars.finalPrice.toFixed(2).replace('.', ',')
					}
				})
			}
		})

		//show final price if more than 1 select
		reservationPriceContainer.style.display = this.vars.finalPrice ? 'block' : 'none'
		reservationSubmitBtn.style.display = this.vars.finalPrice ? 'inline-block' : 'none'
		bookingInput.value = this.vars.finalPrice && true
		reservationRatePlanType.innerHTML = this.vars.finalPrice ? ratePlanName : ''
		reservationRatePlanType.style.display = this.vars.finalPrice ? 'block' : 'none'

		this.fxCalculateContentSummaryHeight()
	},

	init() {
		if (this.el.formReservation) {
			this.fxCalculateContentSummaryHeight()
			this.fxUpdateRatePlanValue()
		}
	}
}

reservationHelper.init()